import React, { Component } from 'react'
import { LocalStorageService, PlanService, UserDocService, UserService, AddressService, UserDocSuppService } from '../../../services'
import { ProfileAdministrationView } from '../../views'
import { formatPhoneNumber, formatPhoneNumberIntl } from 'react-phone-number-input'
import hash from 'object-hash'
import moment from 'moment'
import LanguageService from '../../../services/language.service'
import { useTranslation } from 'react-i18next'

class ProfileAdministrationAction extends Component {
    constructor(props) {
        super(props)

        this.state = {
            isLoadingView: false,
            token: '',
            user: {},
            showLoadingRequesting: false,
            showErrorRequesting: false,
            showCompletedRequesting: false,
            messageError: '',
            firstName: '',
            firstLastName: '',
            secondLastName: '',
            preferredLanguage: '',
            userFullName: '',
            userPhone: '',
            cellphoneNumber: '',
            phoneNumber: '',
            userPathImage: '',
            userMail: '',
            userFullDirection: '',
            userId: 0,
            userTypeId: 0,
            languageId: '',
            clientId: 0,
            rfc: '',
            curp: '',
            addressId: '',
            personTypeId: 0,
            organization: '',
            firstName: '',
            lastName: '',
            planName: '',
            signsAvailable: 0,
            totalSigns: 0,
            expirationDate: '',
            monthlyTransactions: 0,
            pricing: 0,
            contractPlanExist: false,
            userImage: '',
            address: {},
            languages: []
        }
    }

    url = process.env.REACT_APP_MIFIRMA_API
    localStorageService = new LocalStorageService()
    planService = new PlanService(this.url)
    userDocService = new UserDocService(this.url)
    userService = new UserService(this.url)
    addressService = new AddressService(this.url)
    userDocSuppService = new UserDocSuppService(this.url)
    userInfo = {}

    token = ''
    user = {}
    newImage = ''

    async componentDidMount() {
        this.toggleLoadingView(true)
        this.token = this.localStorageService.getLocalStorageItem('token').idToken
        this.user = this.localStorageService.getLocalStorageItem('user')
        this.newImage = this.localStorageService.getLocalStorageItem('newImage')
        this.userInfo = this.localStorageService.getLocalStorageItem('user')

        let messageError = 'Ocurrió un error al consultar la información del usuario'
        try {
            this.getUserData()
            this.getContractPlan()
            this.getUserDocSupps()
            this.getLanguages()
            this.getUserDocs()
        } catch (error) {
            this.toggleLoadingView(false)
            this.toggleErrorRequesting(messageError, 4000, true, '/')
        }
    }

    toggleLoadingView = (value) => {
        this.setState({
            isLoadingView: value
        })
    }

    toggleLoadingRequesting = (value) => {
        this.setState({
            showLoadingRequesting: value,
        })
    }

    toggleCloseErrorRequesting = () => {
        this.setState({
            showErrorRequesting: false
        })
    }

    toggleErrorRequesting = (message, time, sendInbox, path) => {
        let sendTo = (path && path !== '') ? path : '/'
        this.setState({
            showErrorRequesting: true,
            messageError: message
        }, () => {
            setTimeout(() => {
                this.setState({
                    showErrorRequesting: false,
                })
                if (sendInbox) {
                    const locationState = this.props.location.state
                    if (locationState && locationState.from) {
                        this.props.history.push({
                            pathname: locationState.from,
                            state: locationState
                        })
                    } else {
                        this.props.history.push(sendTo)
                    }
                }
            }, time || 4000)
        })
    }

    toggleCompletedRequesting = (time, sendInbox, path) => {
        let sendTo = (path && path !== '') ? path : '/'
        this.setState({
            showCompletedRequesting: true,
        }, () => {
            setTimeout(() => {
                this.setState({
                    showCompletedRequesting: false,
                })
                if (sendInbox) {
                    const locationState = this.props.location.state
                    if (locationState && locationState.from) {
                        this.props.history.push({
                            pathname: locationState.from,
                            state: locationState
                        })
                    } else {
                        this.props.history.push(sendTo)
                    }
                }
            }, time || 4000)
        })
    }

    getUserData = async () => {
        let messageError = 'Ocurrió un error al consultar la información del usuario'
        try {
            let user = await this.userService.getUser(this.userInfo.userToken.sub, this.token)
            if (user) {
                let A3CloudData = user.userA3Cloud
                let miFirmaData = user.userMifirma
                let firstName = A3CloudData.firstName
                let firstLastName = A3CloudData.firstLastName
                let secondLastName = A3CloudData.secondLastName
                let fullName = `${A3CloudData.firstName} ${A3CloudData.firstLastName} ${A3CloudData.secondLastName}`
                let userEmail = `${A3CloudData.email}`
                let phoneValue = (A3CloudData.phoneNumber) ? A3CloudData.phoneNumber : (A3CloudData.cellphoneNumber) ? A3CloudData.cellphoneNumber : ''
                let userPhone = `${phoneValue}`
                let imageUser = (this.newImage) ? this.newImage : (A3CloudData.profilePicture) ? A3CloudData.profilePicture : this.user.userMetaData.userAuth0.picture
                let pathImage = `${imageUser}`
                let { countryCodeCellphone, countryCodePhone } = A3CloudData

                let address = A3CloudData.address || {}
                let userAddress = '--------'
                if (
                    address?.street &&
                    address?.street !== null &&
                    address?.street !== ' ' &&
                    address?.colony &&
                    address?.colony !== null &&
                    address?.colony !== ' ' &&
                    address?.township &&
                    address?.township !== null &&
                    address?.township !== ' ' &&
                    address?.state &&
                    address?.state !== null &&
                    address?.state !== ' ' &&
                    address?.zipCode &&
                    address?.zipCode !== null &&
                    address?.zipCode !== ' ' &&
                    address?.country &&
                    address?.country !== null &&
                    address?.country !== ' '
                ) {
                    userAddress = `${address?.street ?? ''}, Col. ${address?.colony ?? ''}, ${address?.township ?? ''}, ${address?.state ?? ''}, C.P. ${address?.zipCode ?? ''}`
                }

                this.setState({
                    firstName,
                    firstLastName,
                    secondLastName,
                    userFullName: fullName,
                    userPhone: userPhone,
                    cellphoneNumber: countryCodeCellphone || phoneValue,
                    phoneNumber: countryCodePhone,
                    userPathImage: pathImage,
                    userMail: userEmail,
                    userFullDirection: userAddress,
                    address: A3CloudData.address,
                    userId: A3CloudData.id,
                    userTypeId: miFirmaData.userType.id,
                    languageId: miFirmaData.language.id,
                    clientId: A3CloudData.clientId,
                    rfc: A3CloudData.rfc,
                    curp: A3CloudData.curp,
                    addressId: A3CloudData.address.id,
                    personTypeId: A3CloudData.client.personTypeId,
                    organization: A3CloudData.client.organization,
                    firstName: A3CloudData.firstName,
                    lastName: ` ${A3CloudData.firstLastName} ${A3CloudData.secondLastName}`,
                    preferredLanguage: user.userMifirma.language.id
                })
                this.toggleLoadingView(false)
            } else {
                this.toggleLoadingView(false)
                this.toggleErrorRequesting(messageError, 4000, true, '/')
            }
        } catch (error) {
            this.toggleLoadingView(false)
            this.toggleErrorRequesting(messageError, 4000, true, '/')
        }
    }

    getLanguages = async () => {
        const languages = await LanguageService.getLanguages(this.token)
        this.setState({ languages: languages.data })
    }

    getContractPlan = async () => {
        let messageError = 'Ocurrió un error al consultar el plan del contrato'
        moment.locale('es')
        try {
            let userContractPlan = await this.planService.getUserContractAndPlan(this.token)
            if (userContractPlan && userContractPlan.data && Number(userContractPlan.statusCode) === 200) {
                let dateExpiration = userContractPlan.data.contract.endOfContract.split('T')[0]

                this.setState({
                    planName: userContractPlan.data.plan.name,
                    signsAvailable: userContractPlan.data.contract.availableTransaction,
                    totalSigns: userContractPlan.data.contract.annualTransaction,
                    expirationDate: moment(dateExpiration).format('DD/MMMM/YYYY'),
                    monthlyTransactions: userContractPlan.data.contract.monthlyTransaction,
                    pricing: userContractPlan.data.contract.pricing,
                    contractPlanExist: true,
                })

                this.toggleLoadingView(false)
            } else {
                this.toggleLoadingView(false)
                this.toggleErrorRequesting(messageError, 4000, true, '/')
            }
        } catch (error) {
            this.toggleLoadingView(false)
            this.toggleErrorRequesting(messageError, 4000, true, '/')
        }
    }

    handleImage = async (e) => {
        this.toggleLoadingRequesting(true)
        let messageError = 'Ocurrió un error al cargar la imagen de perfil'
        let reader = new FileReader()

        try {
            if (!e || !e.target || !e.target.files || !e.target.files[0]) {
                messageError = 'Seleccionar un archivo'
                this.toggleLoadingRequesting(false)
                this.toggleErrorRequesting(messageError, 4000, true, '/')
                return
            }

            if (e.target.files[0].size < 4194304) {
                reader.onload = async (e) => {
                    this.setState({
                        userPathImage: e.target.result,
                    })
                    await this.localStorageService.setLocalStorageItem(
                        'newImage',
                        e.target.result
                    )
                }

                reader.readAsDataURL(e.target.files[0])
                this.setState({
                    userImage: e.target.files[0],
                })
                let updateFile = new FormData()
                updateFile.append('file', e.target.files[0])
                await this.userDocService.getUserDocProfile(updateFile, this.token)
                this.toggleLoadingRequesting(false)
                this.toggleCompletedRequesting(4000, false, '/')
            } else {
                messageError = this.props.t('dialogUpdateUserAddress.ImageError')
                this.toggleLoadingRequesting(false)
                this.toggleErrorRequesting(messageError, 4000, false, '/')
                return
            }
        } catch (error) {
            this.toggleLoadingRequesting(false)
            this.toggleErrorRequesting(messageError, 4000, false, '/')
        }
    }

    updateUser = async (data) => {
        this.toggleLoadingRequesting(true)
        let messageError = 'Ocurrió un error al acutalizar la información del usuario'
        let eventId = hash({ hash: Math.random().toString(36).substring(7) })
        let { firstName, firstLastName, secondLastName, cellphoneNumber, phoneNumber, rfc, curp, languageId } = data
        let { clientId, addressId, userTypeId } = this.state


        let splittedNumber = formatPhoneNumberIntl(cellphoneNumber).split(' ')

        let countryCodePhone = splittedNumber.splice(0, 1)[0]
        let countryCodeCellphone = countryCodePhone
        phoneNumber = splittedNumber.join('')
        cellphoneNumber = phoneNumber

        let userData = {
            eventId,
            firstName,
            clientId,
            addressId,
            firstLastName,
            secondLastName,
            phoneNumber,
            cellphoneNumber,
            countryCodePhone,
            countryCodeCellphone,
            userTypeId,
            languageId,
            rfc,
            curp,
            termnsAndConditions: true,
        }

        try {
            let userUpdated = await this.userService.updateUser(userData, this.token)
            if (userUpdated && userUpdated.data && Number(userUpdated.statusCode) === 200) {
                const foundLanguageKey = this.state.languages.find(item => item.isoKey === this.localStorageService.getLocalStorageItem('preferredLanguage'))

                if (foundLanguageKey.id !== Number(languageId)) {
                    const itemFound = this.state.languages.find(item => item.id === Number(languageId))
                    this.localStorageService.setLocalStorageItem('preferredLanguage', itemFound.isoKey)
                    this.props.i18n.changeLanguage(itemFound.isoKey)
                    window.location.reload()
                }

                let {
                    cellphoneNumber,
                    firstName,
                    firstLastName,
                    secondLastName,
                    phoneNumber,
                    rfc,
                    curp
                } = userUpdated.data.userA3CloudUpdate.data

                let updateData = {
                    cellphoneNumber,
                    firstName,
                    firstLastName,
                    secondLastName,
                    phoneNumber,
                    rfc,
                    curp
                }

                let localUserData = {
                    ...this.localStorageService.getLocalStorageItem('user'),
                }

                localUserData.userMetaData.userA3Cloud = {
                    ...localUserData.userMetaData.userA3Cloud,
                    ...updateData,
                }

                this.localStorageService.setLocalStorageItem('user', localUserData)
                this.toggleLoadingRequesting(false)
                this.toggleCompletedRequesting(3000, false, '/')
            } else {
                this.toggleLoadingRequesting(false)
                this.toggleErrorRequesting(messageError, 4000, false, '/')
            }
        } catch (error) {
            this.toggleLoadingRequesting(false)
            this.toggleErrorRequesting(messageError, 4000, false, '/')
        }
    }

    updateAddress = async (data, handleShowPrincipalView) => {
        this.toggleLoadingRequesting(true)
        let messageError = 'Ocurrió un error al acutalizar el domicilio del usuario'
        let { addressId, street, internalNumber, externalNumber, colony, township, state, country, zipCode } = data

        try {
            let addressUpdated = await this.addressService.updateAddress(addressId, street, internalNumber, externalNumber, colony, township, state, country, zipCode, this.token)
            if (addressUpdated && addressUpdated.data && Number(addressUpdated.statusCode) === 200) {
                let userAddressUpdated = {
                    street,
                    colony,
                    township,
                    state,
                    zipCode,
                    id: addressId
                }
                this.setState({
                    address: userAddressUpdated
                })

                let localUserData = {
                    ...this.localStorageService.getLocalStorageItem('user'),
                }
                let updateData = {}
                let addressUpdateData = {}

                addressUpdateData.street = addressUpdated.data.data.street
                addressUpdateData.externalNumberValue = addressUpdated.data.data.externalNumber
                addressUpdateData.colony = addressUpdated.data.data.colony
                addressUpdateData.internalNumber = addressUpdated.data.data.internalNumber
                addressUpdateData.zipCode = addressUpdated.data.data.zipCode
                addressUpdateData.township = addressUpdated.data.data.township
                addressUpdateData.state = addressUpdated.data.data.state
                addressUpdateData.country = addressUpdated.data.data.country
                updateData.addressUpdateData = addressUpdateData

                localUserData.userMetaData.userA3Cloud.address = {
                    ...localUserData.userMetaData.userA3Cloud.address,
                    ...updateData.addressUpdateData,
                }

                this.localStorageService.setLocalStorageItem('user', localUserData)
                this.toggleLoadingRequesting(false)
                this.toggleCompletedRequesting(3000, false, '/')
                handleShowPrincipalView()
            } else {
                this.toggleLoadingRequesting(false)
                this.toggleErrorRequesting(messageError, 4000, false, '/')
            }
        } catch (error) {
            this.toggleLoadingRequesting(false)
            this.toggleErrorRequesting(messageError, 4000, false, '/')
        }
    }


    getUserDocSupps = async () => {
        let messageError = 'Ocurrió un error al obtener las imágenes de la crendencial'
        try {
            let result = await this.userDocSuppService.getUserDocSupps(this.token)
            if (result) {
                let { autographySignImg, ineFrontImg, ineBackImg } = result
                this.setState({
                    //   signatureImg: 'data:image/pngbase64,' + autographySignImg,
                    ineFrontImg: 'data:image/pngbase64,' + ineFrontImg,
                    ineBackImg: 'data:image/pngbase64,' + ineBackImg,
                })
            }
        } catch (error) {
            this.toggleLoadingRequesting(false)
            this.toggleErrorRequesting(messageError, 4000, false, '/')
        }
    }

    getUserDocs = async () => {
        let messageError = 'Ocurrió un error al obtener los documentos'
        try {
            let result = await this.userDocService.getUserDocs(this.token)
            if (result && result.statusCode === 200) {
                let expiratedFDA = false, expiratedBaseSign = false

                let FDADocuments = result.data.filter(document => document.docTypeId === 4 || document.docTypeId === 6)
                let baseSignDocuments = result.data.filter(document => document.docTypeId === 8)

                if (FDADocuments.some(document => new Date(document.expirationDate) < new Date())) expiratedFDA = true
                if (baseSignDocuments.some(document => new Date(document.expirationDate) < new Date())) expiratedBaseSign = true

                let fdaLabel, baseSignLabel
                if (FDADocuments.length === 0) fdaLabel = this.props.t('profileAdministrationPrincipalView.btn.fda')
                else if (FDADocuments.length > 0 && !expiratedFDA) fdaLabel = this.props.t('profileAdministrationPrincipalView.btn.recoveryFda')
                else if (FDADocuments.length > 0 && expiratedFDA) fdaLabel = 'profileAdministrationPrincipalView.btn.renewFda'

                if (baseSignDocuments.length === 0) baseSignLabel = this.props.t('profileAdministrationPrincipalView.btn.base.sign')
                else if (baseSignDocuments.length > 0) baseSignLabel = this.props.t('profileAdministrationPrincipalView.btn.recoveryBaseSign')

                this.setState({
                    fdaLabel,
                    baseSignLabel
                })
            }
        } catch (error) {
            this.toggleLoadingRequesting(false)
            this.toggleErrorRequesting(messageError, 4000, false, '/')
        }
    }

    render() {
        return (
            <ProfileAdministrationView
                {...this.state}
                {...this.props}

                handleImage={this.handleImage}
                updateUser={this.updateUser}
                updateAddress={this.updateAddress}

                toggleLoadingRequesting={this.toggleLoadingRequesting}
                toggleCompletedRequesting={this.toggleCompletedRequesting}
                toggleErrorRequesting={this.toggleErrorRequesting}
                toggleCloseErrorRequesting={this.toggleCloseErrorRequesting}
            />
        )
    }
}

function ProfileAdministrationActionContainer(props) {
    const { t, i18n } = useTranslation()

    return (
        <ProfileAdministrationAction
            {...props}
            t={t}
            i18n={i18n}
        />
    )
}

export { ProfileAdministrationActionContainer as default }

